import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "../components/SEO";
import Reveal from "../components/Reveal";
import Breadcrumbs from "../components/Breadcrumbs";
import CTASection from "../components/CTASection";
import { getResources } from "../lib/api";

export default function Resources() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getResources().then(setArticles).catch(() => setArticles([])).finally(() => setLoading(false));
  }, []);
  return (
    <>
      <SEO
        title="Resources"
        description="Dumpster sizing guides, roll-off rental tips, and waste service answers from the local team at Yavapai Waste Solutions."
        path="/resources"
      />
      <section className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-12">
          <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Resources" }]} />
          <div className="mt-8 max-w-3xl">
            <h1 className="font-heading font-extrabold tracking-tight text-4xl sm:text-5xl text-slate-900 leading-[1.05]">Resources</h1>
            <p className="mt-4 text-lg text-slate-600 leading-relaxed">
              Straight answers on dumpster sizes, rentals, and waste service — from the local team that does it every day.
            </p>
          </div>
        </div>
      </section>

      <section className="py-14 bg-slate-50 min-h-[40vh]" data-testid="resources-grid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <p className="text-slate-500">Loading articles…</p>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map((a, i) => (
                <Reveal key={a.slug} delay={i * 0.05}>
                  <Link
                    to={`/resources/${a.slug}`}
                    className="group flex flex-col h-full bg-white rounded-xl border border-slate-200 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all"
                    data-testid={`resource-${a.slug}`}
                  >
                    {a.image && (
                      <img src={a.image} alt={a.title} className="w-full aspect-[16/9] object-cover" loading="lazy" />
                    )}
                    <div className="p-6 flex flex-col flex-1">
                      <time className="text-xs text-slate-400 font-medium">{a.date}</time>
                      <h2 className="font-heading font-bold text-lg text-slate-900 mt-2 group-hover:text-sky-700 transition-colors leading-snug">{a.title}</h2>
                      <p className="mt-2 text-sm text-slate-600 leading-relaxed flex-1">{a.excerpt}</p>
                      <span className="inline-flex items-center gap-1.5 mt-4 text-sm font-heading font-semibold text-sky-700 group-hover:gap-2.5 transition-all">
                        Read more <ArrowRight className="h-4 w-4" />
                      </span>
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>

      <CTASection title="Still Have Questions?" subtitle="Call (928) 713-2710 and talk to a real person — Monday–Friday, 8 AM–5 PM." />
    </>
  );
}
